import { combineTokens, makeSelectors } from '@utils/css';
import { colors } from '../../design-tokens/colors.js';

const tokens = combineTokens("--input-border", {
  dimmed: colors.gray.sim10(),
  hover: colors.gray.sim65(),
  focus: colors.gray.sim100(),
  backgroundColor: colors.gray.sim00()
});
const modifiers = makeSelectors({
  active: "dibamd98zq",
  empty: "dibe1nlrhnz",
  invalid: "dibiesevt",
  readOnly: "dibr1sfcfym",
  disabled: "dibd6qt5nm"
});
const wrapper = "dibw1yw05n5";
const label = "dibl1q9ymg3";

// Responsible for "removing" the border of the input behind the label while the
// input has text
const borderClearer = "dibb1170u4v";
const errorMessage = "dibeem04qi";
const inputBorderSelectors = makeSelectors({
  wrapper,
  label
});

export { borderClearer, errorMessage, modifiers as inputBorderModifiers, inputBorderSelectors, tokens as inputBorderTokens, label, modifiers, tokens, wrapper };
import "./atom.input-border.style.linaria.module.css";
//# sourceMappingURL=atom.input-border.style.js.map
